import { fetch } from '@atlassian/eoc-fetch';

import { type ApiKeyResponse } from '../../common/types';

export const fetchKeys = async (accountId: string): Promise<ApiKeyResponse> => {
	return fetch<ApiKeyResponse>('/api-keys/web?accountId=' + accountId);
};

export const deleteApiKey = async (
	key: string,
	accountId: string,
): Promise<{
	isSuccess: boolean;
}> => {
	return fetch<{ isSuccess: boolean }>(`/api-keys/web?apiKey=${key}&accountId=${accountId}`, {
		method: 'DELETE',
	});
};
